import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  private data: any;

  setData(value: any): void {
    this.data = value;
  }

  getData(): any {
    return this.data;
  }
}
